import { loaderDisplayed } from 'actions/loaderDisplayed';

import { verifyScanId } from 'requests';

import { handleUnsuccessfulFormSubmit } from 'thunks/handleUnsuccessfulSubmit';

export const verifyScanIdSubmit = (data, displayErrorMessage) => {
  return async dispatch => {
    dispatch(loaderDisplayed());
    try {
      return await verifyScanId({ data });
    } catch (error) {
      dispatch(
        handleUnsuccessfulFormSubmit(
          { error: error.message },
          displayErrorMessage
        )
      );
    }
  };
};
